import { dataDataMarketSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconDataMarketSolid = /*#__PURE__*/createIcon(dataDataMarketSolid)
export default IconDataMarketSolid
